import { render, staticRenderFns } from "./ProductsGalleryModal.vue?vue&type=template&id=3e46ffc2&"
import script from "./ProductsGalleryModal.vue?vue&type=script&lang=js&"
export * from "./ProductsGalleryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports